import { Component } from '@angular/core';
import { HeroComponent } from '../hero/hero.component';
import { PricingTableComponent } from '../pricing-table/pricing-table.component';
import { OperatorWorkspaceSectionComponent } from '../operator-workspace-section/operator-workspace-section.component';
import { ManagedSupportSectionComponent } from '../managed-support-section/managed-support-section.component';
// import { PricingCalculatorComponent } from '../pricing-calculator/pricing-calculator.component';
import { PricingComparisonComponent } from '../pricing-comparison/pricing-comparison.component';
import { GettingStartedSectionComponent } from '../getting-started-section/getting-started-section.component';
import { PricingFaqComponent } from '../pricing-faq/pricing-faq.component';

@Component({
  selector: 'app-pricing-page',
  imports: [
    HeroComponent,
    PricingTableComponent,
    OperatorWorkspaceSectionComponent,
    ManagedSupportSectionComponent,
    // PricingCalculatorComponent,
    PricingComparisonComponent,
    GettingStartedSectionComponent,
    PricingFaqComponent
  ],
  templateUrl: './pricing-page.component.html',
  styleUrl: './pricing-page.component.scss'
})
export class PricingPageComponent {
}
